/**
 * Represents the sub index, a sub section from a selected database.
 */
export enum SubIndex {
  MaintainingEQ = 1,
  ImprovingEQ = 2,
  ImprovingWorm = 3,
  CarcaseGrowth = 4,
  ReproductionCarcaseGrowth = 5,
  FineWool = 6,
  WoolProduction = 15,
  SustainableMerino = 8,
  MerinoLamb = 7,
  ClMaintainingEQ = 16,
  ClImprovingEQ = 18,
  ClImprovingWorm = 19,
  ClRamsJoinedToMerino = 20,
  ClSelfReplacingMAT = 21,
  ClSelfReplacingWormMAT = 22,
  ClSelfReplacingWoolMAT = 24,
  ClTermMaintainingEQ = 25,
  ClTermImprovingEQ = 26,
  ClTermImprovingWorm = 27,
  ClMatRamsJoinedToMerino = 28,
  ClMatSelfReplacingMAT = 29,
  ClMatSelfReplacingWormMAT = 30,
  ClMatSelfReplacingWoolMAT = 31,
  ClFcRamsJoinedToMerino = 32,
  ClCorrSelfReplacingWoolMAT = 33,
  ClSheddMaintainingEQ = 34,
  ClSheddImprovingEQ = 35,
  ClSheddImprovingWorm = 36,
  ClSheddSelfReplacingMAT = 37,
  ClSheddSelfReplacingWormMAT = 38,
}
